import { useContext } from 'react';
import { ThemeContext } from '../../App';

/**
 * Custom hook to access and toggle theme mode
 * @returns {Object} Theme context with mode and toggleMode
 */
const useThemeMode = () => {
  const context = useContext(ThemeContext);

  if (!context) {
    throw new Error('useThemeMode must be used within a ThemeProvider');
  }

  return context;
};

export default useThemeMode;
